export default __webpack_public_path__ + "static/workorder-2b9ea2445123e81f05cf4e7a01894f55.png";